import { DefinedEmits, DefinedProps } from 'SharedDir/declarations/vue';
import { computed } from 'vue';
import { FieldHistory } from 'SharedDir/declarations/fields';

export interface BaseFieldProps {
  label: string;
  showHistory?: boolean;
  history?: FieldHistory[];
}

export interface ValuedFieldProps extends BaseFieldProps {
  readonly?: boolean;
  disable?: boolean;
  required?: boolean;
  useWrapper?: boolean;
  skipValidation?: boolean;
  errorMessage?: string;
}

export interface BaseFieldEmits {
  (e: 'reveal-history', fieldName: string, history: FieldHistory[]): void;
}

// export const defaultBaseProps: Partial<{
//   [K in keyof BaseFieldProps]: BaseFieldProps[K] | (() => BaseFieldProps[K]);
// }> = {
export const defaultBaseProps = {
  showHistory: false,
  history: () => [],
};
export const defaultValuedProps = {
  ...defaultBaseProps,
  readonly: false,
  disable: false,
  required: false,
  useWrapper: false,
  skipValidation: false,
};

export const useBaseFieldProps = <P, E>(
  props: DefinedProps<P & ValuedFieldProps>,
  emit: DefinedEmits<BaseFieldEmits & E>
) => {
  const validationErrorStatus = computed(() => !!props.errorMessage);
  const hasHistory = computed(() => Array.isArray(props.history) && props.history.length > 0);

  const revealHistory = (fieldName) => {
    emit('reveal-history', fieldName, props.history);
  };

  return {
    validationErrorStatus,
    hasHistory,
    revealHistory,
  };
};
